import Vue from 'vue'
import App from './App.vue'
import router from '@/router';
import store from '@/store';
import axios from "axios";
import CKEditor from '@ckeditor/ckeditor5-vue';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'


Vue.component("default-layout", require("./layouts/Default.vue").default);
Vue.component("grant-layout", require("./layouts/Grant.vue").default);
Vue.component("blank-layout", require("./layouts/Blank.vue").default);

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.BASE_URL;
axios.defaults.withCredentials = true;

if (store.getters['auth/isAuthenticated']) {
  axios.defaults.headers.common['Authorization'] = "Bearer " + store.getters['auth/token'];
  axios.defaults.headers.common['Accept'] = "application/json";
  axios.defaults.headers.common['Content-Type'] = "application/json";
}

axios.interceptors.response.use(undefined, function (error) {
  let res = error.response; 0
  if (error == "Cancel") {
    return Promise.reject('Operation canceled by user.')
  }
  else if (!res) {
    //router.push({ name: "error" })
  }

  if (res && res.status === 401 && res.config && !res.config.__isRetryRequest) {
    //console.log(res.status);
    store.commit("auth/logout");
    router.push({ name: "login" });
  }
  return Promise.reject({ ...error })
});

Vue.use(require('vue-moment'));
Vue.use(axios);
Vue.use(BootstrapVue, [{
  breakpoints: [`xs`, 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl']
}])
Vue.use(IconsPlugin)
Vue.use(CKEditor);

Vue.mixin({
  methods: {
    makeToast(variant, title, text = null) {
      this.$bvToast.toast(text, {
        title: title,
        variant: variant,
        solid: true,
        autoHideDelay: 5000,
        appendToast: true,
        toaster: "b-toaster-top-center"
      });
    },
    showStatus(status) {
      let response = "";
      let variant = "secondary";
      switch (status) {
        case "pending":
          response = "Na čekanju";
          variant = "secondary";
          break;
        case "processing":
          response = "Obrada u toku";
          variant = "info";
          break;
        case "accepted":
          response = "Prihvaćen";
          variant = "success";
          break;
        case "rejected":
          response = "Odbijen";
          variant = "danger";
          break;
      }
      return { response, variant };
    },
  }
})


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
